const webDevPackages = [
  {
    id: 5,
    title: 'E-Commerce Platform',
    basePrice: 5000,
    description: 'Fully functional e-commerce site with product management, cart, payment',
    features: [
      'Complete shopping experience',
      'Product catalog & management',
      'Secure payment processing',
      'Customer account system',
      'Order management',
      'Inventory tracking',
      'Mobile-friendly design',
      'SEO-optimized structure'
    ],
    quantityLogic: 'Quantity = number of e-commerce websites',
    isFixedPackage: false,
    isPopular: false,
    serviceID: "price-ecommerce-platform",
    // priceID: 'price_1RE0FiCcpihV42QYi59aOpii'
    priceID: 'price_1RDzKUCcpihV42QYJYjtRu50'
  },
  {
    id: 4,
    title: 'Business Website',
    basePrice: 2500,
    description: 'Full business website (5 pages) + lead form, fast loading, responsive',
    features: [
      'Professional 5-page website',
      'Mobile responsive design',
      'SEO optimization',
      'Lead capture form',
      'Content management system',
      'Fast loading & performance',
      'Basic analytics integration'
    ],
    quantityLogic: 'Quantity = number of business websites',
    isFixedPackage: false,
    isPopular: true,
    serviceID: "price-business-website",
    priceID: 'price_1RDzLRCcpihV42QYZK9kBYs6'
  },
  {
    id: 3,
    title: 'Landing Page Design',
    basePrice: 500,
    description: 'Custom-designed responsive landing page with sections, product/info layout',
    features: [
      'Custom responsive design',
      'SEO-friendly structure',
      'Fast loading optimizations',
      'Lead capture form integration',
      'Analytics setup',
      'Mobile-first approach'
    ],
    quantityLogic: 'Quantity = number of landing pages',
    isFixedPackage: false,
    isPopular: false,
    serviceID: "price-landing-page-design",
    priceID: 'price_1RDzM0CcpihV42QYa6zACI2B'
  },
  {
    id: 2,
    title: 'Page Speed Optimization',
    basePrice: 100,
    description: 'Speed and performance optimization for a single page',
    features: [
      'Core Web Vitals improvement',
      'Code minification & compression',
      'Browser caching implementation',
      'Image & asset optimization',
      'Performance bottleneck analysis'
    ],
    quantityLogic: 'Quantity = number of pages',
    isFixedPackage: false,
    isPopular: false,
    serviceID: "price-page-speed-optimization",
    priceID: 'price_1RDzMbCcpihV42QYwViHngZE'
  },
  {
    id: 1,
    title: 'Image Optimization',
    basePrice: 10,
    description: 'Optimize one image for performance (e.g., size, format)',
    features: [
      'Reduce file size without quality loss',
      'Convert to modern formats (WebP, AVIF)',
      'Optimize for fast loading',
      'Responsive image sizing',
      'Metadata optimization'
    ],
    quantityLogic: 'Quantity = number of images',
    isFixedPackage: false,
    isPopular: false,
    serviceID: "price-image-optimization",
    priceID: 'price_1RDzN8CcpihV42QYBB34fcNm'
  }
];

export default webDevPackages; 